import { useCallback, useRef } from "react";

export const getSingleOptionAutoSelectSignature = <T>(
  options: readonly T[] | undefined,
  getOptionValue: (option: T) => string,
  context = "",
): string => `${context}::${options?.map(getOptionValue).join("|") ?? ""}`;

const isEmptyValue = (value: unknown): boolean => value == null;

export const useSingleOptionAutoSelect = () => {
  const manuallyClearedSignaturesRef = useRef<Record<string, string>>({});

  const shouldAutoSelectSingleOption = useCallback(
    (fieldName: string, signature: string): boolean => manuallyClearedSignaturesRef.current[fieldName] !== signature,
    [],
  );

  const rememberSingleOptionChange = useCallback((fieldName: string, signature: string, value: unknown) => {
    if (isEmptyValue(value)) {
      manuallyClearedSignaturesRef.current[fieldName] = signature;
      return;
    }

    delete manuallyClearedSignaturesRef.current[fieldName];
  }, []);

  return {
    rememberSingleOptionChange,
    shouldAutoSelectSingleOption,
  };
};
